import { DownloadFileDto } from 'nekst-api';
import React from 'react';
import { PDFViewer } from '../PDFViewer';
import { Popup } from '../Popup';

export function DocumentPreviewPopup(
  props: {
    document: DownloadFileDto,
  }
) {
  return (
    <Popup
      title="Preview Document"
      content={(
        <PDFViewer
          pdfUrl={props.document.downloadUrl}
          fileName={props.document.fileName}
        />
      )}
      isBig
    />
  );
}
